import {
  useAppDispatch,
  useAppSelector,
} from "../../../redux-store/CustomReduxHooks";
import { T_CustomerLobDetailObj } from "../../Feature_Login/Login_Types";
import { StockLobCode } from "../../../utils/constants";
import { useCallback, useEffect, useReducer } from "react";
import { useLazyFetchStocksHoldingsFromUserIdQuery } from "../Stockc&Securities_Api";
import { isEmpty } from "lodash";
import { API_STATUS_CODE } from "../../../utils/ApiEndpoints";
import {
  Stocks_HandlingReducerAction,
  Stocks_ReduxInitialState,
} from "./Stocks_ReduxActionHandler";
import { setStocksDashboardDetails } from "../Stocks&Securities_Slice";
import { T_LocalStocksBaseData } from "./Stocks_BaseData_Types";

export const UseStocksBaseDataLoader = (
  loadFor: "primary" | "secondary" = "primary",
  clientId: string = "",
): T_LocalStocksBaseData => {
  const [localState, updateLocalState] = useReducer(
    Stocks_HandlingReducerAction,
    Stocks_ReduxInitialState,
  );
  const dispatch = useAppDispatch();
  const csAppSlice = useAppSelector((st) => st.CsAppSlice);
  const userDetails = csAppSlice.userDetails;
  const stocksSlice = useAppSelector((st) => st.StocksSlice);
  const [
    fetchStocksHoldingsFromUserIdApi,
    { isFetching, error: errorInFetchPortFolioData },
  ] = useLazyFetchStocksHoldingsFromUserIdQuery();

  const customerAndLobDetails = userDetails?.customerAndLobDetails;
  const UserStocksLobId = customerAndLobDetails?.filter(
    (item: T_CustomerLobDetailObj) =>
      item.LOB === StockLobCode && item.PRIMARY_SECONDARY_USER === loadFor,
  );

  const checkAndinitApiFlow = useCallback(() => {
    /** FN for Loading LI Dashboard Details */
    if (isEmpty(UserStocksLobId)) {
      updateLocalState({
        type: "error",
        payload: Error("Stocks lob id not present"),
      });
    } else if (isEmpty(stocksSlice.stockDashboardDetails)) {
      fetchPrimaryUserDashboardDetails();
    } else {
      updateLocalState({ type: "success", payload: "" });
    }
  }, [UserStocksLobId, stocksSlice.stockDashboardDetails, clientId]);

  /** FN for Loading Stocks Dashboard Details */
  const fetchPrimaryUserDashboardDetails = useCallback(async () => {
    if (isFetching) {
      return;
    }
    updateLocalState({ type: "fetching", payload: "" });

    fetchStocksHoldingsFromUserIdApi(clientId).then(async (res) => {
      if (res.data?.code === API_STATUS_CODE.SUCCESS) {
        if (
          isEmpty(res.data.payload) ||
          isEmpty(res.data.payload?.result.NewDataset.Table1)
        ) {
          updateLocalState({ type: "error", payload: Error("Empty List") });
        } else {
          const portfolioData = res.data.payload;
          dispatch(
            setStocksDashboardDetails(
              portfolioData?.result.NewDataset.Table1 || [],
            ),
          );
        }
      } else {
        updateLocalState({ type: "error", payload: Error("Empty List") });
      }
    });
  }, [isFetching, clientId]);

  useEffect(() => {
    if (!isEmpty(clientId)) {
      checkAndinitApiFlow();
    }
  }, [stocksSlice.stockDashboardDetails, clientId]);

  useEffect(() => {
    if (errorInFetchPortFolioData) {
      updateLocalState({
        type: "error",
        payload: (errorInFetchPortFolioData || Error("api failed")) as Error,
      });
    }
  }, [errorInFetchPortFolioData]);

  return localState;
};
